import React from "react";

const Hero = () => {
  return (
    <div className="bg-[#F5F5F5]">
      <div className="max-w-[1116px] pt-[106px] pb-[114px] mx-auto">
        <h1 className="text-5xl leading-[56px] font-bold">
          All coding competitions, <span className="text-orange-500">challenges & hackathons</span>
        </h1>
      </div>
    </div>
  );
};

export default Hero;
